

















































































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import ConnectedUnigestInstance from '@/modules/app-router/model/ConnectedUnigestInstance';
import {DateMixin} from '@/modules/core/date';

/**
 * Detalle de instancia conectada
 *
 * Muestra al usuario un dialogo donde puede consultar los detalles sobre alguna de
 * las instancias de UnigestWeb que se encuentran conectadas
 *
 * @autor Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConnectedInstanceDetail extends mixins(DateMixin) {
    /**
     * Controla la visibilidad del componente
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Instancia actualmente mostrada al usuario
     *
     * @var { ConnectedUnigestInstance }
     */
    @Prop({type: ConnectedUnigestInstance, default: () => new ConnectedUnigestInstance()})
    public instance: ConnectedUnigestInstance

    public statusConfig = {
        CONNECTED: {text: 'Conectado', icon: 'mdi-power-plug'},
        DISCONNECTED: {text: 'Desconectado', icon: 'mdi-power-plug-off'},
        INACTIVE: {text: 'Inactivo', icon: 'mdi-sleep'},
        LOGOUT: {text: 'Sesión cerrada', icon: 'mdi-exit-run'},
    }

    public osIcon = {
        Windows: 'mdi-microsoft-windows',
        Mac: 'apple',
        iOS: 'mdi-apple-ios',
        Android: 'mdi-android',
    }
}
